import React, {useCallback} from 'react';
import I18n from 'app/i18n';

const ErrorFallbackMessage = (): React.ReactElement => {
    const reload = useCallback((): void => window.location.reload(), []);

    return <div className="server-error">
        <div className="server-error__title">{I18n.t('route_error.title')}</div>
        <div className="server-error__buttons">
            <button type="button" className="btn" onClick={reload}>{I18n.t('route_error.reload')}</button>
        </div>
    </div>;
};

export default ErrorFallbackMessage;
